import Invitation from './home/invitation';

export default Invitation;
